/**
 * 
 * @author Quentin Hocdé (@quentinhcd)
 */

const canvasSketch = require('canvas-sketch');
let viewer = new URLSearchParams(window.location.search).get('viewer')

// Ensure ThreeJS is in global scope for the 'examples/'
global.THREE = require('three');

// Include any additional ThreeJS examples below
require('three/examples/js/controls/OrbitControls');
require('three/examples/js/loaders/GLTFLoader');
require('three/examples/js/loaders/DracoLoader');

const settings = {
    // Make the loop animated
    animate: true,
    // Get a WebGL canvas rather than 2D
    context: 'webgl',
    // Turn on MSAA
    attributes: { antialias: true },
    dimensions: [2000, 2000],
    duration: 12
};

const sketch = ({ context }) => {
    // Create a renderer
    const renderer = new THREE.WebGLRenderer({
        context
    });
    const random = (min, max) => Math.random() * (max - min) + min;

    if(viewer == null || viewer == undefined || viewer == 'false') viewer = 'tz1g2ZxQbaePfmpSwPQNRVNaF5aJdVmZWZgL';

    let idNumbers = [];
    let idUppercases = [];
    let randomValue1 = 0;
    let randomValue2 = 0;
    let randomValue3 = 0;
    let randomValue4 = 0;

    for (var i = 0; i < viewer.length; i++) {
        
        // Number of numbers
        if(!isNaN(parseInt(viewer[i]))) {
            idNumbers.push(viewer[i]);
            if(idNumbers.length > 1) {
                randomValue1 = randomValue1 + parseInt(viewer[i]);
            }
        }

        else if(viewer[i] == viewer[i].toUpperCase()) {
            idUppercases.push(viewer[i]);
        }
    }

    randomValue1 = randomValue1 / idNumbers.length;
    randomValue2 = (idUppercases[1].charCodeAt(0) - 65) / 26;
    randomValue3 = (idUppercases[2].charCodeAt(0) - 65) / 26;
    randomValue4 = (idUppercases[0].charCodeAt(0) - 65) / 26;

    const theme = randomValue1;
    const mainColor = new THREE.Color(`${(theme > 4.5) ? '#fff' : '#000'}`);
    const mainMaterial = new THREE.Color(`${(theme > 4.5) ? '#cccccc' : '#000'}`);

    // WebGL background color
    renderer.setClearColor(mainColor, 1);

    // Setup a camera
    const camera = new THREE.PerspectiveCamera(45, 1, 0.01, 100);
    camera.position.set(2.5, 0.5, -2.5);
    camera.lookAt(new THREE.Vector3());

    // Setup camera controller
    const controls = new THREE.OrbitControls(camera, context.canvas);
    controls.enableDamping = true;
    controls.dampingFactor = 0.2;
    controls.rotateSpeed = 0.2;
    controls.enablePan = false;
    controls.enableZoom = false;
    controls.minPolarAngle = Math.PI/2; // radians
    controls.maxPolarAngle = Math.PI/2; // radians


    // Setup your scene
    const scene = new THREE.Scene();

    let texture = new THREE.TextureLoader().load('assets/abstract-texture-14.jpg');

    texture.encoding = THREE.sRGBEncoding;
    texture.mapping = THREE.EquirectangularReflectionMapping;


    let material = new THREE.MeshPhongMaterial({
        color: 0xbbbbbb,
        reflectivity: 0.94,
        shininess: 80,
        specular: 0xffffff,
        side: THREE.DoubleSide, 
        envMap: texture,
        // map: texture
    });

    material.color.setHSL(randomValue2, randomValue3,randomValue4)
    
    let whiteMaterial = new THREE.MeshPhongMaterial({
        color: mainMaterial,
        shininess: 5,
        specular: 0xffffff,
        side: THREE.DoubleSide, 
    });

    let loader = new THREE.GLTFLoader();

    // Optional: Provide a DRACOLoader instance to decode compressed mesh data
    THREE.DRACOLoader.setDecoderPath( 'assets/js/DracoLoader/' );
    loader.setDRACOLoader( new THREE.DRACOLoader() );

    let mesh;
    loader.load(
        // resource URL
        'assets/3d/010-export.glb',
        // called when the resource is loaded
        (data) => {
            mesh = data.scene;
            scene.add(mesh);
            mesh.rotation.set(0,0,Math.PI/2.4);
            mesh.position.set(0,-0.5,-1);

            data.scene.traverse(node => {
                if(node.name === "male_headobj") {
                    node.material = whiteMaterial;
                } else {
                    node.material = material;
                }
            });

        },
        // called while loading is progressing
        (xhr) => {
            console.log((xhr.loaded / xhr.total * 100) + '% loaded');
        },
        // called when loading has errors
        (error) => {
            console.log(error);
            console.log('An error happened');
        }
    );


    // Specify an ambient/unlit colour
    scene.add(new THREE.AmbientLight('#cccccc'));

    // // Add some light
    const light = new THREE.PointLight('#ffffff', 0.5);
    light.position.set(5, 5, 5).multiplyScalar(1.5);
    scene.add(light);

    const backLight = new THREE.PointLight('#ffffff', 0.5);
    backLight.position.set(-5, 5, -5);
    scene.add(backLight);

    const eyes = new THREE.PointLight('#ffffff', 1);
    eyes.position.set(0, 0, 0);
    scene.add(eyes);

        
    // draw each frame
    return {
        // Handle resize events here
        resize({ pixelRatio, viewportWidth, viewportHeight }) {
            renderer.setPixelRatio(pixelRatio);
            renderer.setSize(viewportWidth, viewportHeight);
            camera.aspect = viewportWidth / viewportHeight;
            camera.updateProjectionMatrix();
        },
        // And render events here
        render({ time, deltaTime }) {
            if(mesh !== undefined) {
                // scene.rotation.y = (time * (30 * Math.PI / 180)) - Math.PI/2;
            }
            controls.update();
            renderer.render(scene, camera);
        },
        // Dispose of WebGL context (optional)
        unload() {
            renderer.dispose();
        }
    };
};

canvasSketch(sketch, settings);